let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: '品牌',
    props: 'vehicleBrand',
    minWidth: 200,
  },
  {
    label: '车型',
    props: 'vehicleModel',
    minWidth: 200,
  },
  {
    label: '备注',
    props: 'remark',
    minWidth: 200,
  },
  {
    label: '创建人',
    props: 'createdByName',
    minWidth: 200,
  },
  {
    label: '创建日期 ',
    props: 'createdWhen',
    minWidth: 200,
  },
  {
    label: '更新人',
    props: 'lastModifiedByName',
    minWidth: 200,
  },
  {
    label: '更新日期',
    props: 'lastModifiedWhen',
    minWidth: 200,
  },
  {
    label: '状态',
    props: 'invokeFlag',
    minWidth: 120,
    align: 'center',
    formatter: (row) => {
      // 启用: Y / y / 1 / true
      const isEnabled = row.invokeFlag === 'Y' || row.invokeFlag === 'y' || row.invokeFlag === 1 || row.invokeFlag === '1' || row.invokeFlag === true;
      // 停用: N / n / 0 / false
      const isDisabled = row.invokeFlag === 'N' || row.invokeFlag === 'n' || row.invokeFlag === 0 || row.invokeFlag === '0' || row.invokeFlag === false;
      if (isEnabled) {
        return '<span style="display:inline-block;padding:0 8px;height:20px;line-height:18px;font-size:12px;border-radius:4px;background:#f0f9eb;color:#67c23a;border:1px solid #e1f3d8">启用</span>';
      }
      if (isDisabled) {
        return '<span style="display:inline-block;padding:0 8px;height:20px;line-height:18px;font-size:12px;border-radius:4px;background:#fef0f0;color:#f56c6c;border:1px solid #fde2e2">停用</span>';
      }
      return '-';
    }
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
  type: 'title',
  name: '首页',
},
{
  type: 'title',
  name: '车辆基础信息管理'
},
{
  type: 'title',
  name: '车辆型号管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: 'pileTypeNo',
  editRouter: 'VehicleModelDetail',
};

// 路由
pageConfig.listRouter = 'modelList';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
  type: 'title',
  name: '首页',
},
{
  type: 'title',
  name: '车辆基础信息管理',
},
{
  type: 'router',
  name: '车辆型号管理',
  router: 'modelList'
},
{
  type: 'title',
  name: '车辆型号详情',
},
];

pageConfig.formRules = {
  vehicleModel: [{
    required: true,
    message: '请填写车辆型号',
    trigger: 'blur'
  }],
  vehicleBrand: [{
    required: true,
    message: '请填写车辆品牌',
    trigger: 'blur'
  }],
  invokeFlag: [
    {
      required: true,
      message: '请选择状态',
      trigger: 'change'
    }
  ],
};



export default pageConfig;
